// Country name to ISO Alpha-3 code mapping for choropleth maps
export const countryNameToISO = {
  'Afghanistan': 'AFG',
  'Albania': 'ALB',
  'Algeria': 'DZA',
  'Argentina': 'ARG',
  'Armenia': 'ARM',
  'Australia': 'AUS',
  'Austria': 'AUT',
  'Azerbaijan': 'AZE',
  'Bahrain': 'BHR',
  'Bangladesh': 'BGD',
  'Belarus': 'BLR',
  'Belgium': 'BEL',
  'Bolivia': 'BOL',
  'Bosnia and Herzegovina': 'BIH',
  'Bosnia and Herz.': 'BIH',
  'Brazil': 'BRA',
  'Bulgaria': 'BGR',
  'Cambodia': 'KHM',
  'Canada': 'CAN',
  'Chile': 'CHL',
  'China': 'CHN',
  'Colombia': 'COL',
  'Croatia': 'HRV',
  'Czech Republic': 'CZE',
  'Denmark': 'DNK',
  'Ecuador': 'ECU',
  'Egypt': 'EGY',
  'Estonia': 'EST',
  'Ethiopia': 'ETH',
  'Finland': 'FIN',
  'France': 'FRA',
  'Georgia': 'GEO',
  'Germany': 'DEU',
  'Ghana': 'GHA',
  'Greece': 'GRC',
  'Hungary': 'HUN',
  'Iceland': 'ISL',
  'India': 'IND',
  'Indonesia': 'IDN',
  'Iran': 'IRN',
  'Iraq': 'IRQ',
  'Ireland': 'IRL',
  'Israel': 'ISR',
  'Italy': 'ITA',
  'Japan': 'JPN',
  'Jordan': 'JOR',
  'Kazakhstan': 'KAZ',
  'Kenya': 'KEN',
  'Kuwait': 'KWT',
  'Latvia': 'LVA',
  'Lebanon': 'LBN',
  'Lithuania': 'LTU',
  'Luxembourg': 'LUX',
  'Malaysia': 'MYS',
  'Mexico': 'MEX',
  'Morocco': 'MAR',
  'Netherlands': 'NLD',
  'New Zealand': 'NZL',
  'Nigeria': 'NGA',
  'Norway': 'NOR',
  'Pakistan': 'PAK',
  'Peru': 'PER',
  'Philippines': 'PHL',
  'Poland': 'POL',
  'Portugal': 'PRT',
  'Qatar': 'QAT',
  'Romania': 'ROU',
  'Russia': 'RUS',
  'Russian Federation': 'RUS',
  'Saudi Arabia': 'SAU',
  'Serbia': 'SRB',
  'Singapore': 'SGP',
  'Slovakia': 'SVK',
  'Slovenia': 'SVN',
  'South Africa': 'ZAF',
  'South Korea': 'KOR',
  'Spain': 'ESP',
  'Sri Lanka': 'LKA',
  'Sweden': 'SWE',
  'Switzerland': 'CHE',
  'Thailand': 'THA',
  'Turkey': 'TUR',
  'Türkiye': 'TUR',
  'Ukraine': 'UKR',
  'United Arab Emirates': 'ARE',
  'United Kingdom': 'GBR',
  'United States': 'USA',
  'Uruguay': 'URY',
  'Venezuela': 'VEN',
  'Vietnam': 'VNM',
  // Additional countries for better coverage
  'Taiwan': 'TWN',
  'Hong Kong': 'HKG',
  'Macao': 'MAC',
  'Puerto Rico': 'PRI',
  'Malta': 'MLT',
  'Monaco': 'MCO',
  'San Marino': 'SMR',
  'Vatican City': 'VAT',
  'Cyprus': 'CYP',
  'N. Cyprus': 'CYP',
  'Palestine': 'PSE',
  'Liechtenstein': 'LIE',
  'Andorra': 'AND',
  'Bahamas': 'BHS',
  'Barbados': 'BRB',
  'Jamaica': 'JAM',
  'Trinidad and Tobago': 'TTO',
  'Cuba': 'CUB',
  'Dominican Republic': 'DOM',
  'Haiti': 'HTI',
  'Costa Rica': 'CRI',
  'Panama': 'PAN',
  'Guatemala': 'GTM',
  'Honduras': 'HND',
  'El Salvador': 'SLV',
  'Nicaragua': 'NIC',
  'Belize': 'BLZ',
  'Paraguay': 'PRY',
  'Guyana': 'GUY',
  'Suriname': 'SUR',
  'French Guiana': 'GUF',
  'Falkland Islands': 'FLK',
  'Falkland Is.': 'FLK',
  'South Georgia': 'SGS',
  'Antarctica': 'ATA',
  'Fr. S. Antarctic Lands': 'ATF',
  'Greenland': 'GRL',
  'Faroe Islands': 'FRO',
  'Isle of Man': 'IMN',
  'Jersey': 'JEY',
  'Guernsey': 'GGY',
  'Gibraltar': 'GIB',
  'Åland Islands': 'ALA',
  'Svalbard': 'SJM',
  'Jan Mayen': 'SJM',
  'Bouvet Island': 'BVT',
  'Heard Island': 'HMD',
  'McDonald Islands': 'HMD',
  'Norfolk Island': 'NFK',
  'Christmas Island': 'CXR',
  'Cocos Islands': 'CCK',
  'Cook Islands': 'COK',
  'Niue': 'NIU',
  'Tokelau': 'TKL',
  'American Samoa': 'ASM',
  'Samoa': 'WSM',
  'Tonga': 'TON',
  'Fiji': 'FJI',
  'Vanuatu': 'VUT',
  'Solomon Islands': 'SLB',
  'Solomon Is.': 'SLB',
  'Papua New Guinea': 'PNG',
  'Palau': 'PLW',
  'Micronesia': 'FSM',
  'Marshall Islands': 'MHL',
  'Kiribati': 'KIR',
  'Nauru': 'NRU',
  'Tuvalu': 'TUV',
  'French Polynesia': 'PYF',
  'New Caledonia': 'NCL',
  'Wallis and Futuna': 'WLF',
  'Pitcairn': 'PCN',
  'Guam': 'GUM',
  'Northern Mariana Islands': 'MNP',
  'Virgin Islands': 'VIR',
  'British Virgin Islands': 'VGB',
  'Anguilla': 'AIA',
  'Montserrat': 'MSR',
  'Saint Kitts and Nevis': 'KNA',
  'Antigua and Barbuda': 'ATG',
  'Dominica': 'DMA',
  'Saint Lucia': 'LCA',
  'Saint Vincent and the Grenadines': 'VCT',
  'Grenada': 'GRD',
  'Aruba': 'ABW',
  'Curaçao': 'CUW',
  'Sint Maarten': 'SXM',
  'Bonaire': 'BES',
  'Saint Barthélemy': 'BLM',
  'Saint Martin': 'MAF',
  'Saint Pierre and Miquelon': 'SPM',
  'Bermuda': 'BMU',
  'Cayman Islands': 'CYM',
  'Turks and Caicos Islands': 'TCA',
  'Seychelles': 'SYC',
  'Mauritius': 'MUS',
  'Comoros': 'COM',
  'Mayotte': 'MYT',
  'Réunion': 'REU',
  'Madagascar': 'MDG',
  'Mozambique': 'MOZ',
  'Zimbabwe': 'ZWE',
  'Zambia': 'ZMB',
  'Malawi': 'MWI',
  'Tanzania': 'TZA',
  'Uganda': 'UGA',
  'Rwanda': 'RWA',
  'Burundi': 'BDI',
  'Democratic Republic of the Congo': 'COD',
  'Dem. Rep. Congo': 'COD',
  'Republic of the Congo': 'COG',
  'Central African Republic': 'CAF',
  'Central African Rep.': 'CAF',
  'Chad': 'TCD',
  'Sudan': 'SDN',
  'South Sudan': 'SSD',
  'Eritrea': 'ERI',
  'Djibouti': 'DJI',
  'Somalia': 'SOM',
  'Somaliland': 'SOM',
  'Cameroon': 'CMR',
  'Equatorial Guinea': 'GNQ',
  'Gabon': 'GAB',
  'São Tomé and Príncipe': 'STP',
  'Angola': 'AGO',
  'Namibia': 'NAM',
  'Botswana': 'BWA',
  'Lesotho': 'LSO',
  'Eswatini': 'SWZ',
  'Swaziland': 'SWZ',
  'Liberia': 'LBR',
  'Sierra Leone': 'SLE',
  'Guinea': 'GIN',
  'Guinea-Bissau': 'GNB',
  'Gambia': 'GMB',
  'Senegal': 'SEN',
  'Mali': 'MLI',
  'Burkina Faso': 'BFA',
  'Niger': 'NER',
  'Ivory Coast': 'CIV',
  'Côte d\'Ivoire': 'CIV',
  'Togo': 'TGO',
  'Benin': 'BEN',
  'Cape Verde': 'CPV',
  'Mauritania': 'MRT',
  'Western Sahara': 'ESH',
  'W. Sahara': 'ESH',
  'Tunisia': 'TUN',
  'Libya': 'LBY',
  'Mongolia': 'MNG',
  'North Korea': 'PRK',
  'Myanmar': 'MMR',
  'Burma': 'MMR',
  'Laos': 'LAO',
  'Brunei': 'BRN',
  'Timor-Leste': 'TLS',
  'East Timor': 'TLS',
  'Bhutan': 'BTN',
  'Nepal': 'NPL',
  'Maldives': 'MDV',
  'Tajikistan': 'TJK',
  'Kyrgyzstan': 'KGZ',
  'Uzbekistan': 'UZB',
  'Turkmenistan': 'TKM',
  'Yemen': 'YEM',
  'Oman': 'OMN',
  'Syria': 'SYR',
  'North Macedonia': 'MKD',
  'Macedonia': 'MKD',
  'Montenegro': 'MNE',
  'Kosovo': 'XKX',
  'Moldova': 'MDA',
  'Transnistria': 'MDA'
};

// Function to get ISO code from country name
export const getCountryISO = (countryName) => {
  if (!countryName) return null;
  
  // Direct lookup
  if (countryNameToISO[countryName]) {
    return countryNameToISO[countryName];
  }
  
  // Try partial matching for common variations
  const normalizedName = countryName.toLowerCase().trim();
  
  // Handle common variations and abbreviations
  const variations = {
    'united states': 'USA',
    'usa': 'USA',
    'us': 'USA',
    'america': 'USA',
    'united kingdom': 'GBR',
    'uk': 'GBR',
    'britain': 'GBR',
    'great britain': 'GBR',
    'england': 'GBR',
    'scotland': 'GBR',
    'wales': 'GBR',
    'northern ireland': 'GBR',
    'south korea': 'KOR',
    'korea': 'KOR',
    'republic of korea': 'KOR',
    'russia': 'RUS',
    'russian federation': 'RUS',
    'ussr': 'RUS',
    'soviet union': 'RUS',
    'united arab emirates': 'ARE',
    'uae': 'ARE',
    'emirates': 'ARE',
    'czech republic': 'CZE',
    'czechia': 'CZE',
    'bosnia': 'BIH',
    'herzegovina': 'BIH',
    'north macedonia': 'MKD',
    'macedonia': 'MKD',
    'fyrom': 'MKD',
    'congo': 'COG',
    'drc': 'COD',
    'democratic republic of congo': 'COD',
    'ivory coast': 'CIV',
    'cote d\'ivoire': 'CIV',
    'myanmar': 'MMR',
    'burma': 'MMR',
    'east timor': 'TLS',
    'timor leste': 'TLS',
    'swaziland': 'SWZ',
    'eswatini': 'SWZ',
    'cape verde': 'CPV',
    'cabo verde': 'CPV',
    'vatican': 'VAT',
    'holy see': 'VAT',
    'taiwan': 'TWN',
    'republic of china': 'TWN',
    'hong kong': 'HKG',
    'macau': 'MAC',
    'macao': 'MAC'
  };
  
  // Check direct variations first
  if (variations[normalizedName]) {
    return variations[normalizedName];
  }
  
  // Try fuzzy matching with better logic
  for (const [name, iso] of Object.entries(countryNameToISO)) {
    const nameNormalized = name.toLowerCase();
    // Exact match or contains match (but avoid false positives)
    if (nameNormalized === normalizedName || 
        (normalizedName.length > 3 && nameNormalized.includes(normalizedName)) ||
        (normalizedName.length > 3 && normalizedName.includes(nameNormalized))) {
      return iso;
    }
  }
  
  // Log unknown countries for debugging
  console.warn('Unknown country name:', countryName);
  return null;
};

// Color scale for choropleth map
export const getCountryColor = (count, maxCount) => {
  if (!count || count === 0) return '#f3f4f6'; // gray-100
  
  const intensity = count / maxCount;
  
  if (intensity >= 0.8) return '#1e40af'; // blue-800
  if (intensity >= 0.6) return '#2563eb'; // blue-600
  if (intensity >= 0.4) return '#3b82f6'; // blue-500
  if (intensity >= 0.2) return '#60a5fa'; // blue-400
  if (intensity >= 0.1) return '#93c5fd'; // blue-300
  return '#dbeafe'; // blue-100
};

// Dark theme color scale
export const getCountryColorDark = (count, maxCount) => {
  if (!count || count === 0) return '#374151'; // gray-700
  
  const intensity = count / maxCount;
  
  if (intensity >= 0.8) return '#1e40af'; // blue-800
  if (intensity >= 0.6) return '#2563eb'; // blue-600
  if (intensity >= 0.4) return '#3b82f6'; // blue-500
  if (intensity >= 0.2) return '#60a5fa'; // blue-400
  if (intensity >= 0.1) return '#93c5fd'; // blue-300
  return '#1f2937'; // gray-800
};